export default __webpack_public_path__ + "media/images/carnival/destination_2_sp-ba07eaa39a2e5e75329e84b72ee3dee7.jpg";